module.exports = __webpack_public_path__ + "4efa13aadfa0123bb8426f7e54d8ef6c.png";